<template>
    <div class="c-switch-modal" :class="{ 'is-disabled': switchIsSubmitting }">
        <div class="c-switch-modal__header">
            <Header />
        </div>

        <div class="c-switch-modal__content">
            <div class="c-switch-content" v-if="!isInitialAddressesFetch">
                <div
                    class="c-switch-content__section c-switch-content__section--addresses"
                    v-if="showTabs"
                >
                    <div v-if="!isAutocompleteShown" class="c-switch-content__section__title">
                        {{ addressesTitle }}
                    </div>

                    <Autocomplete v-if="isAutocompleteShown" :title="addressesTitle" />

                    <div v-else class="c-switch-content__section__select">
                        <component
                            :is="filteredAddresses.length > 2 ? 'AddressSelect' : 'AddressList'"
                        ></component>
                    </div>

                    <div class="c-switch-content__section__link">
                        <button
                            type="button"
                            class="c-link"
                            v-if="showAddAddressLink"
                            @click="shopType === 'b2b' ? redirectToNewAddress() : addNewAddress()"
                        >
                            <span class="sc-text">{{ $t("Switch.Addresses.addAddress") }}</span>
                            <i class="ico ico-chevron-right-thick" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>

                <div
                    class="c-switch-content__section c-switch-content__section--datetime"
                    v-if="datesAndTimesAreVisible && !hasError"
                >
                    <div class="c-switch-content__section__title">
                        {{ $t("Switch.Dates.title") }}
                    </div>

                    <div class="c-switch-content__section__select">
                        <Dates />
                    </div>

                    <div class="c-switch-content__section__select">
                        <Times />
                    </div>
                </div>

                <div
                    class="c-switch-content__section c-switch-content__section--messages"
                    v-if="hasError"
                >
                    <div
                        v-if="processErrorMessage && activeAddressesTab === 'courier'"
                        class="c-msg c-msg--error is-flash"
                        v-html="processErrorMessage"
                    ></div>

                    <div
                        v-if="datesErrorMessage"
                        class="c-msg c-msg--error is-flash"
                        v-html="datesErrorMessage"
                    ></div>
                </div>
            </div>
        </div>

        <div class="c-switch-modal__footer">
            <div class="c-switch-footer">
                <button
                    type="button"
                    class="c-btn c-btn--secondary"
                    :class="{ 'is-loading': switchIsSubmitting }"
                    :disabled="!isReadyForSubmit"
                    @click="submitSwitch"
                >
                    {{ $t("Switch.Footer.btn1") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "./Header";
import AddressSelect from "./AddressSelect.vue";
import AddressList from "./AddressList.vue";
import Autocomplete from "./Autocomplete.vue";
import Dates from "./Dates.vue";
import Times from "./Times.vue";

export default {
    components: {
        Header,
        AddressSelect,
        AddressList,
        Autocomplete,
        Dates,
        Times,
    },
    created() {
        this.$store.commit("SET_NEW_ADDRESS_CHECKED", false);
        this.$store.dispatch("fetchAddresses");
    },
    methods: {
        submitSwitch() {
            if (!this.switchIsSubmitting) {
                this.$store.dispatch("submitSwitch");
            }

            this.$store.commit("SET_SWITCH_IS_SUBMITTING", true);
        },
        addNewAddress() {
            this.$store.commit("SET_MAIN_COMPONENT", "MainAddress");
        },
        redirectToNewAddress() {
            if (window.location.pathname === "/moje-adresy") {
                location.href = "/moje-adresy#new-address-modal";
                location.reload();
            } else {
                location.href = "/moje-adresy#new-address-modal";
            }
        },
    },
    computed: {
        ...mapState([
            "shopType",
            "processErrorMessage",
            "datesErrorMessage",
            "courierAddresses",
            "isInitialAddressesFetch",
            "switchIsSubmitting",
            "activeAddressesTab",
        ]),
        ...mapGetters([
            "isAutocompleteShown",
            "hasError",
            "showTabs",
            "isReadyForSubmit",
            "datesAndTimesAreVisible",
            "addressesTitle",
            "filteredAddresses",
            "showAddAddressLink",
        ]),
    },
};
</script>
